exports.utils = require("./utils");
exports.OBJECT = require("./objects");
exports.PARCEL_STATUS = require("./parcelStatuses");
exports.COLLECTION_STATUS = require("./collectionStatuses");
exports.IMAGE_TYPE = require("./imageTypes");
exports.PARCEL_DASHBOARD_TYPES = require("./parcelDashboardTypes");
exports.ISSUE_CODE = require("./issues").ISSUE_CODE;
exports.ISSUE_NAME = require("./issues").ISSUE_NAME;
exports.USER_TYPE = require("./userTypes");
exports.ORIGIN = require("./origins");
exports.PARCEL_ACTION_CODE = require("./actionCodes").PARCEL_ACTION_CODE; // new variable
exports.COLLECTION_ACTION_CODE = require("./actionCodes").COLLECTION_ACTION_CODE;
exports.PICKUP_LOCATION_STATUS = require("./pickupLocationStatuses");
exports.ERROR_CODE = require("./errorCodes");
exports.SAFE_PLACE_TYPE = require("./safePlaces").types;
exports.SAFE_PLACE_NAME = require("./safePlaces").names;
exports.COLLECTION_TYPE = require("./collectionTypes").COLLECTION_TYPE;
exports.COLLECTION_TYPES_ENUM = require("./collectionTypes").COLLECTION_TYPES_ENUM;
exports.COLLECTION_TYPE_DESCRIPTION = require("./collectionTypes").COLLECTION_TYPE_DESCRIPTION;
exports.COLLECTION_DASH_TYPE = require("./collectionTypes").COLLECTION_DASH_TYPE;
exports.SORT_ORDER = require("./sortOrder");
exports.COUNTRIES_ENUM = require("./countries").COUNTRIES_ENUM;
exports.COUNTRIES_ROW = require("./countries").COUNTRIES_RAW;
exports.COMPLIMENT_TYPE = require("./complimentTypes");
exports.DELIVERY_COMPLIMENT_TYPE = require("./complimentTypes").DELIVERY;
exports.DRIVER_COMPLIMENT_TYPE = require("./complimentTypes").DRIVER;
exports.NEED_MORE_TIME_CODE = require("./needMoreTimeCodes");
exports.ELECTRIC_VEHICLE = require("./vehicleTypeCodes").ELECTRIC_VEHICLE;
exports.SYNC_ACTION_TYPE = require("./syncActionTypes");
exports.THEME_EVENT = require("./themeEvents");

// shipping enums
exports.SHIPMENT_TYPE = require("./shipment").SHIPMENT_TYPE;
exports.ADDRESS_TYPE = require("./shipment").ADDRESS_TYPE;

// reference dom enums
exports.DOM_DPD_SERVICE = require("./domDpdServices");
exports.DOM_LOCAL_SERVICE = require("./domLocalServices");
exports.DOM_NETWORK = require("./domNetworks");
exports.DOM_SERVICE = require("./domServices");
